import { ApiService } from "../..";

export const createFeedback = (data: { feedback_content: string; feedback_attachment_url: string[] }) => {
  return ApiService.baseAction(
    "feedback/create",
    {
      data,
    },
    "post"
  );
};
